import { render, staticRenderFns } from "./PublicEvent.vue?vue&type=template&id=25ddf07c&scoped=true&"
import script from "./PublicEvent.vue?vue&type=script&lang=js&"
export * from "./PublicEvent.vue?vue&type=script&lang=js&"
import style0 from "./PublicEvent.vue?vue&type=style&index=0&id=25ddf07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ddf07c",
  null
  
)

export default component.exports